import { axiosPost } from './axiosService';

const baseHyperPayURL = '/hyperpay';

export class HyperPayService {
	
	createCheckout(checkoutData) {
		return axiosPost(checkoutData, baseHyperPayURL + '/create-checkout');
	}

	getPaymentStatus(statusRequest) {
		return axiosPost(statusRequest, baseHyperPayURL + '/payment-status');
	}
}

